import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import userStore from "../../../zustand/userStore";
import { userPrefill, userPrefill2 } from "../../../configs/WebService";
import { apiKeyHeader } from "../../../configs/ApiKeys";
// const BASE_URL = "https://web1024.docmaster.in:5010/prefill";

const handleThunkError = (error, thunkAPI) => {
  const errorMessage = error.response?.data?.message || error.message;
  return thunkAPI.rejectWithValue(errorMessage);
};

// export const fetchPrefillsByUserId = createAsyncThunk(
//   "prefill/fetchByUserId",
//   async (user_id, thunkAPI) => {
//     try {
//       const response = await axios.get(`${userPrefill}/${user_id}`,{
//           headers: apiKeyHeader(),

//       },);
//       return response.data;
//     } catch (error) {
//       return handleThunkError(error, thunkAPI);
//     }
//   }
// );
export const fetchPrefillsByUserId = createAsyncThunk(
  "prefill/fetchByUserId",
  async (user_id, thunkAPI) => {
    try {
      const userData = userStore.getState().user;
      const role = userData?.role;
      let apiUrl;
      if (role === "student") {
        apiUrl = `${userPrefill2}/${user_id}`;
      } else {
        apiUrl = `${userPrefill}/${user_id}`;
      }
      const response = await axios.get(apiUrl, {
        headers: apiKeyHeader(),
      });

      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI);
    }
  }
);

// export const createPrefill = createAsyncThunk(
//   "prefill/create",
//   async (payload, thunkAPI) => {
//     try {
//       const response = await axios.post(
//         `${userPrefill}/insert-prefill`,
//         payload,
//         {
//           headers: apiKeyHeader(),
//         }
//       );
//       thunkAPI.dispatch(fetchPrefillsByUserId(payload.user_id));
//       return response.data;
//     } catch (error) {
//       return handleThunkError(error, thunkAPI);
//     }
//   }
// );
export const createPrefill = createAsyncThunk(
  "prefill/create",
  async (payload, thunkAPI) => {
    try {
      const userData = userStore.getState().user;
      const role = userData?.role;

      let apiUrl;
      if (role === "student") {
        apiUrl = `${userPrefill2}/insert-prefill`;
      } else {
        apiUrl = `${userPrefill}/insert-prefill`;
      }

      const response = await axios.post(apiUrl, payload, {
        headers: apiKeyHeader(),
      });
      thunkAPI.dispatch(fetchPrefillsByUserId(payload.user_id));

      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI);
    }
  }
);

// export const updatePrefillById = createAsyncThunk(
//   "prefill/update",
//   async ({ id, field_key, field_value }, thunkAPI) => {
//     try {
//       const response = await axios.put(
//         `${userPrefill}/${id}`,
//         {
//           field_key,
//           field_value,
//         },
//         {
//           headers: apiKeyHeader(),
//         }
//       );
//       const user_id = userStore.getState().user.id;
//       thunkAPI.dispatch(fetchPrefillsByUserId(user_id));
//       return response.data;
//     } catch (error) {
//       return handleThunkError(error, thunkAPI);
//     }
//   }
// );
export const updatePrefillById = createAsyncThunk(
  "prefill/update",
  async ({ id, field_key, field_value }, thunkAPI) => {
    try {
      const userData = userStore.getState().user;
      const role = userData?.role;
      let apiUrl;
      if (role === "student") {
        apiUrl = `${userPrefill2}/${id}`;
      } else {
        apiUrl = `${userPrefill}/${id}`;
      }
      const response = await axios.put(
        apiUrl,
        { field_key, field_value },
        { headers: apiKeyHeader() }
      );
      const user_id = userData.id;
      thunkAPI.dispatch(fetchPrefillsByUserId(user_id));

      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI);
    }
  }
);
